const numberCurrency = ( number ) => {
    return new Intl.NumberFormat("ES-GT", {
        style: "currency",
        currency: "GTQ"
    }).format(number);
}

export default numberCurrency;